import React from 'react'
import { Layout } from '../layouts'
import UCHAppSample from "../assets/img/uch/uch-app-sample.png"
import BgBookStack from "../assets/img/uch/bookstack.png"
import HealthCareRuleImg from "../assets/img/uch/healthcare-rule.png"
import SurveyReportImg from "../assets/img/uch/survey.png"
import UserPersonaImage from "../assets/img/uch/user-persona.png"
import HMWTemplateImg from "../assets/img/uch/hmw-template.png"
import StatementTextImg from "../assets/img/uch/statement-text.png"
import TechnicalBusinessImg from '../assets/img/uch/technical-and-business-goals.png'
import InformationArchitectureImg from '../assets/img/uch/info-arch.png'
import UserFlowImg from '../assets/img/uch/user-flow.png'
import SignInSketch from '../assets/img/uch/sketch-1.png'
import SignUpSketch from '../assets/img/uch/sketch-2.png'
import MainScreenSketch from '../assets/img/uch/sketch-3.png'
import SplashScreenImg from '../assets/img/uch/splash-screen.png'
import SigninScreenImg from '../assets/img/uch/signin-screen.png'
import NavigationScreenImg from '../assets/img/uch/navigation-screen.png'
import RecordScreenImg from '../assets/img/uch/records-screen.png'
import UsabilityStudiesImg from '../assets/img/uch/usability.png'
import MakingAdjustmentImg from '../assets/img/uch/making-adjustment.png'
import RequestFormImg from '../assets/img/uch/request-form.png'
import RequestFormProcessImg from '../assets/img/uch/mobile_mockup.png'
import { ShowcasePagination } from '../components/ShowcasePagination'
import { caseStudyLists } from '../contents/data'
import { observationStudyContents } from '../contents/uch'
import DocumentImg from '../assets/img/uch/storyboard.png'
import VoiceAssistantImg from '../assets/img/uch/voice-assistant.png'

const problemOptions = [
    {
        title: "Observation Study",
        text: "To gain firsthand knowledge of the difficulties that patients are currently facing at the hospital.",
        svg: `<svg width="71" height="65" viewBox="0 0 71 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.117 13.7498C10.117 10.1031 11.5657 6.60581 14.1443 4.02722C16.7228 1.44863 20.2202 0 23.8668 0C27.5135 0 31.0108 1.44863 33.5894 4.02722C36.168 6.60581 37.6166 10.1031 37.6166 13.7498C37.6166 17.3965 36.168 20.8938 33.5894 23.4724C31.0108 26.051 27.5135 27.4996 23.8668 27.4996C20.2202 27.4996 16.7228 26.051 14.1443 23.4724C11.5657 20.8938 10.117 17.3965 10.117 13.7498ZM42.6166 21.2497C42.6166 19.7723 42.9075 18.3095 43.4729 16.9446C44.0383 15.5797 44.8669 14.3395 45.9116 13.2949C46.9562 12.2502 48.1964 11.4216 49.5613 10.8562C50.9262 10.2908 52.389 9.99985 53.8664 9.99985C55.3437 9.99985 56.8066 10.2908 58.1715 10.8562C59.5364 11.4216 60.7766 12.2502 61.8212 13.2949C62.8659 14.3395 63.6945 15.5797 64.2599 16.9446C64.8252 18.3095 65.1162 19.7723 65.1162 21.2497C65.1162 24.2333 63.931 27.0948 61.8212 29.2045C59.7115 31.3143 56.85 32.4995 53.8664 32.4995C50.8827 32.4995 48.0213 31.3143 45.9116 29.2045C43.8018 27.0948 42.6166 24.2333 42.6166 21.2497ZM0.117188 56.2492C0.117188 49.9504 2.61938 43.9095 7.0733 39.4556C11.5272 35.0017 17.568 32.4995 23.8668 32.4995C30.1656 32.4995 36.2064 35.0017 40.6604 39.4556C45.1143 43.9095 47.6165 49.9504 47.6165 56.2492V56.2592L47.6131 56.6558C47.6061 57.0797 47.4913 57.4949 47.2797 57.8622C47.068 58.2296 46.7664 58.5371 46.4032 58.7558C39.6006 62.8523 31.8076 65.0112 23.8668 64.999C15.627 64.999 7.91374 62.7191 1.33384 58.7558C0.970012 58.5375 0.667736 58.2302 0.455471 57.8628C0.243206 57.4954 0.127938 57.0801 0.120521 56.6558L0.117188 56.2492ZM52.6164 56.2592L52.6131 56.7392C52.5944 57.8502 52.3292 58.9432 51.8364 59.9391C57.6553 60.298 63.4676 59.1378 68.7028 56.5725C69.1077 56.3746 69.4515 56.0709 69.698 55.6936C69.9444 55.3163 70.0843 54.8795 70.1028 54.4292C70.2205 51.6334 69.6142 48.8545 68.3426 46.3618C67.071 43.8691 65.1772 41.747 62.8447 40.2011C60.5122 38.6551 57.82 37.7377 55.0289 37.5377C52.2378 37.3377 49.4423 37.8619 46.9132 39.0594C50.6237 44.0213 52.6239 50.0533 52.6131 56.2492V56.2592H52.6164Z" fill="#219653"/></svg>`,
    },
    {
        title: "User Interview and Survey",
        text: "To gain a thorough understanding of patients' difficulties and areas for improvement.",
        svg: `<svg width="51" height="64" viewBox="0 0 51 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1434 13.6378C12.1434 10.0208 13.5803 6.55201 16.1379 3.99442C18.6954 1.43684 22.1643 0 25.7812 0C29.3982 0 32.8671 1.43684 35.4246 3.99442C37.9822 6.55201 39.4191 10.0208 39.4191 13.6378C39.4191 17.2548 37.9822 20.7236 35.4246 23.2812C32.8671 25.8388 29.3982 27.2756 25.7812 27.2756C22.1643 27.2756 18.6954 25.8388 16.1379 23.2812C13.5803 20.7236 12.1434 17.2548 12.1434 13.6378ZM0.781612 56.3848C0.883805 49.8219 3.56264 43.5624 8.23986 38.9574C12.9171 34.3525 19.2176 31.7714 25.7812 31.7714C32.3449 31.7714 38.6454 34.3525 43.3226 38.9574C47.9999 43.5624 50.6787 49.8219 50.7809 56.3848C50.7888 56.8266 50.6677 57.2612 50.4325 57.6352C50.1973 58.0093 49.8581 58.3067 49.4565 58.4911C42.0289 61.8966 33.9523 63.6542 25.7812 63.6432C17.3379 63.6432 9.31586 61.8005 2.106 58.4911C1.70439 58.3067 1.36524 58.0093 1.13002 57.6352C0.894802 57.2612 0.773728 56.8266 0.781612 56.3848Z" fill="#A78BFA"/></svg>`,
    },
    {
        title: "Market Research",
        text: "To comprehend the regulations in place for the management of patient healthcare records in Nigerian hospitals.",
        svg: `<svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.4492 0C16.1184 0 0.449219 15.6692 0.449219 35C0.449219 54.3308 16.1184 70 35.4492 70C54.78 70 70.4492 54.3308 70.4492 35C70.4492 15.6692 54.78 0 35.4492 0ZM31.4108 16.1538C29.0903 16.1543 26.8025 16.7001 24.7317 17.7472C22.6609 18.7943 20.8652 20.3134 19.4894 22.182C18.1136 24.0506 17.1962 26.2164 16.8112 28.5047C16.4262 30.7929 16.5844 33.1397 17.273 35.3556C17.9615 37.5715 19.1613 39.5946 20.7754 41.2617C22.3894 42.9288 24.3727 44.1932 26.5653 44.953C28.7578 45.7128 31.0982 45.9466 33.3977 45.6357C35.6973 45.3248 37.8915 44.4778 39.8036 43.1631L47.0082 50.3641C47.2547 50.6286 47.5519 50.8408 47.8822 50.9879C48.2124 51.1351 48.5689 51.2142 48.9304 51.2206C49.2919 51.227 49.651 51.1605 49.9862 51.0251C50.3215 50.8896 50.626 50.6881 50.8817 50.4324C51.1373 50.1768 51.3389 49.8723 51.4743 49.537C51.6097 49.2018 51.6762 48.8427 51.6698 48.4812C51.6634 48.1197 51.5843 47.7632 51.4372 47.4329C51.29 47.1027 51.0778 46.8055 50.8133 46.559L43.6123 39.3544C45.1419 37.131 46.0348 34.5319 46.1945 31.8379C46.3542 29.1439 45.7747 26.4575 44.5185 24.069C43.2624 21.6805 41.3773 19.6807 39.0671 18.2856C36.757 16.8906 34.1095 16.1535 31.4108 16.1538Z" fill="#F2994A"/></svg>`
    },
]

const needOptions = [
    {
        title: "User Persona",
        text: "Come up with a persona to make our solution human centered",
        svg: `<svg width="51" height="64" viewBox="0 0 51 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1434 13.6378C12.1434 10.0208 13.5803 6.55201 16.1379 3.99442C18.6954 1.43684 22.1643 0 25.7812 0C29.3982 0 32.8671 1.43684 35.4246 3.99442C37.9822 6.55201 39.4191 10.0208 39.4191 13.6378C39.4191 17.2548 37.9822 20.7236 35.4246 23.2812C32.8671 25.8388 29.3982 27.2756 25.7812 27.2756C22.1643 27.2756 18.6954 25.8388 16.1379 23.2812C13.5803 20.7236 12.1434 17.2548 12.1434 13.6378ZM0.781612 56.3848C0.883805 49.8219 3.56264 43.5624 8.23986 38.9574C12.9171 34.3525 19.2176 31.7714 25.7812 31.7714C32.3449 31.7714 38.6454 34.3525 43.3226 38.9574C47.9999 43.5624 50.6787 49.8219 50.7809 56.3848C50.7888 56.8266 50.6677 57.2612 50.4325 57.6352C50.1973 58.0093 49.8581 58.3067 49.4565 58.4911C42.0289 61.8966 33.9523 63.6542 25.7812 63.6432C17.3379 63.6432 9.31586 61.8005 2.106 58.4911C1.70439 58.3067 1.36524 58.0093 1.13002 57.6352C0.894802 57.2612 0.773728 56.8266 0.781612 56.3848Z" fill="#6D29D9"/></svg>`,
    },
    {
        title: "Brainstorming",
        text: "Brainstorm with other designers to explore possible design solutions",
        svg: `<svg width="71" height="65" viewBox="0 0 71 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.117 13.7498C10.117 10.1031 11.5657 6.60581 14.1443 4.02722C16.7228 1.44863 20.2202 0 23.8668 0C27.5135 0 31.0108 1.44863 33.5894 4.02722C36.168 6.60581 37.6166 10.1031 37.6166 13.7498C37.6166 17.3965 36.168 20.8938 33.5894 23.4724C31.0108 26.051 27.5135 27.4996 23.8668 27.4996C20.2202 27.4996 16.7228 26.051 14.1443 23.4724C11.5657 20.8938 10.117 17.3965 10.117 13.7498ZM42.6166 21.2497C42.6166 19.7723 42.9075 18.3095 43.4729 16.9446C44.0383 15.5797 44.8669 14.3395 45.9116 13.2949C46.9562 12.2502 48.1964 11.4216 49.5613 10.8562C50.9262 10.2908 52.389 9.99985 53.8664 9.99985C55.3437 9.99985 56.8066 10.2908 58.1715 10.8562C59.5364 11.4216 60.7766 12.2502 61.8212 13.2949C62.8659 14.3395 63.6945 15.5797 64.2599 16.9446C64.8252 18.3095 65.1162 19.7723 65.1162 21.2497C65.1162 24.2333 63.931 27.0948 61.8212 29.2045C59.7115 31.3143 56.85 32.4995 53.8664 32.4995C50.8827 32.4995 48.0213 31.3143 45.9116 29.2045C43.8018 27.0948 42.6166 24.2333 42.6166 21.2497ZM0.117188 56.2492C0.117188 49.9504 2.61938 43.9095 7.0733 39.4556C11.5272 35.0017 17.568 32.4995 23.8668 32.4995C30.1656 32.4995 36.2064 35.0017 40.6604 39.4556C45.1143 43.9095 47.6165 49.9504 47.6165 56.2492V56.2592L47.6131 56.6558C47.6061 57.0797 47.4913 57.4949 47.2797 57.8622C47.068 58.2296 46.7664 58.5371 46.4032 58.7558C39.6006 62.8523 31.8076 65.0112 23.8668 64.999C15.627 64.999 7.91374 62.7191 1.33384 58.7558C0.970012 58.5375 0.667736 58.2302 0.455471 57.8628C0.243206 57.4954 0.127938 57.0801 0.120521 56.6558L0.117188 56.2492ZM52.6164 56.2592L52.6131 56.7392C52.5944 57.8502 52.3292 58.9432 51.8364 59.9391C57.6553 60.298 63.4676 59.1378 68.7028 56.5725C69.1077 56.3746 69.4515 56.0709 69.698 55.6936C69.9444 55.3163 70.0843 54.8795 70.1028 54.4292C70.2205 51.6334 69.6142 48.8545 68.3426 46.3618C67.071 43.8691 65.1772 41.747 62.8447 40.2011C60.5122 38.6551 57.82 37.7377 55.0289 37.5377C52.2378 37.3377 49.4423 37.8619 46.9132 39.0594C50.6237 44.0213 52.6239 50.0533 52.6131 56.2492V56.2592H52.6164Z" fill="#209653"/></svg>`,
    },
    {
        title: "Define Goals",
        text: "Clearly state both user, technical and business needs",
        svg: `<svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.6526 1.60007C21.5208 1.16564 22.4783 0.939453 23.4492 0.939453C24.4201 0.939453 25.3776 1.16564 26.2459 1.60007L42.8892 9.92674C43.2425 10.1001 43.6559 10.1001 44.0092 9.92674L56.9059 3.47674C57.8587 3.00071 58.9173 2.77608 59.9814 2.82416C61.0454 2.87224 62.0794 3.19144 62.9854 3.75146C63.8914 4.31148 64.6393 5.09374 65.158 6.024C65.6767 6.95426 65.949 8.00164 65.9492 9.06674V50.6834C65.9492 53.0501 64.6125 55.2167 62.4925 56.2734L46.2426 64.3967C45.3752 64.8301 44.4188 65.0557 43.4492 65.0557C42.4796 65.0557 41.5233 64.8301 40.6559 64.3967L24.0092 56.0734C23.8354 55.9863 23.6436 55.941 23.4492 55.941C23.2548 55.941 23.063 55.9863 22.8892 56.0734L9.99589 62.5234C9.04296 63.0002 7.98395 63.2255 6.91946 63.1778C5.85497 63.1301 4.82035 62.811 3.91389 62.2509C3.00742 61.6908 2.25921 60.9082 1.74032 59.9775C1.22144 59.0469 0.949113 57.999 0.949219 56.9334V15.3167C0.949219 12.9501 2.28589 10.7834 4.40255 9.72674L20.6526 1.60341V1.60007ZM23.4492 13.0001C24.1123 13.0001 24.7481 13.2635 25.217 13.7323C25.6858 14.2011 25.9492 14.837 25.9492 15.5001V43.0001C25.9492 43.6631 25.6858 44.299 25.217 44.7678C24.7481 45.2367 24.1123 45.5001 23.4492 45.5001C22.7862 45.5001 22.1503 45.2367 21.6815 44.7678C21.2126 44.299 20.9492 43.6631 20.9492 43.0001V15.5001C20.9492 14.837 21.2126 14.2011 21.6815 13.7323C22.1503 13.2635 22.7862 13.0001 23.4492 13.0001ZM45.9492 23.0001C45.9492 22.337 45.6858 21.7011 45.217 21.2323C44.7481 20.7635 44.1123 20.5001 43.4492 20.5001C42.7862 20.5001 42.1503 20.7635 41.6815 21.2323C41.2126 21.7011 40.9492 22.337 40.9492 23.0001V50.5001C40.9492 51.1631 41.2126 51.799 41.6815 52.2678C42.1503 52.7367 42.7862 53.0001 43.4492 53.0001C44.1123 53.0001 44.7481 52.7367 45.217 52.2678C45.6858 51.799 45.9492 51.1631 45.9492 50.5001V23.0001Z" fill="#BE185D"/></svg>`,
    },
]

const solutionOptions = [
    {
        title: "Information Architecture",
        text: "Creating the information, hierarchies, and features for the first version of the product.",
    },
    {
        title: "User Flow",
        text: "Displaying some of the key path's of the user's through the product, from entry point right through to the final interaction.",
    },
]

const Hero = () => {
    return (
        <div className="mx-auto px-6 py-8 md:py-28 text-center bg-black w-full md:h-screen">
            <div className="mx-auto max-w-3xl py-12">
                <p className="mt-6 text-primary text-lg">
                    UX Case Study
                </p>
                <h1 className="pt-6 text-3xl font-bold text-white leading-12 lg:text-4xl">
                    UCH E-Records App
                </h1>
            </div>
            <div className='max-w-5xl w-full mt-3 sm:mt-8 mx-auto'>
                <img src={UCHAppSample} alt="UCH App Sample" />
            </div>
        </div>
    )
}

const OverviewSection = () => {
    return (
        <>
            <div className="bg-white md:pt-72 2xl:pt-32 py-6 container mx-auto">
                <div className='flex w-full flex-wrap py-4 sm:py-16'>
                    <div className="w-full sm:w-3/4 md:w-5/6 sm:border-l border-primary">
                        <div className='px-4 md:px-10'>
                            <div>
                                <h1 className="text-2xl sm:text-4xl font-bold text-primary leading-12">
                                    Overview
                                </h1>
                                <p className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                                    Over 700 doctors who are specialists in various fields of medicine work 
                                    at the University College Hospital in Ibadan, Nigeria. As one of the 
                                    country's leading teaching hospitals, they would like to provide a 
                                    suitable and cost-effective alternative to handling patient case note requests 
                                    and transfers across the hospital's various clinical departments. As a result, 
                                    in order to make hospital visits less stressful for patients, a solution 
                                    that would make service delivery more efficient in this regard is required.
                                </p>
                            </div>
                            <div>
                                <h1 className="text-2xl sm:text-4xl font-bold text-primary leading-12">
                                    My Role
                                </h1>
                                <p className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                                    I worked on this project as both the UX and UI Designer. It was an eight-week project that 
                                    required me to conduct research within the hospital in order to generate data that would 
                                    assist me in making informed design decisions.
                                </p>
                            </div>
                            <div>
                                <h1 className="text-2xl sm:text-4xl font-bold text-primary leading-12">
                                    End Result
                                </h1>
                                <p className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                                    Despite the challenges of conducting research in a hospital setting , 
                                    this project provided me with the opportunity to create an MVP that can 
                                    help alleviate the ongoing stress associated with patients requesting 
                                    medical records prior to their appointment with their physician.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full sm:w-1/4 md:w-1/6 sm:order-first">
                        <dl className='sm:space-y-8 pt-2 px-4 sm:block grid grid-cols-2'>
                            <div>
                                <dt className='font-semibold pb-2'>
                                    Duration
                                </dt>
                                <dd className='font-light'>
                                    8 Weeks
                                </dd>
                            </div>
                            <div>
                                <dt className='font-semibold pb-2'>
                                    Year
                                </dt>
                                <dd className='font-light'>
                                    2022
                                </dd>
                            </div>
                            <div>
                                <dt className='font-semibold pb-2'>
                                    Industry
                                </dt>
                                <dd className='font-light'>
                                    Health
                                </dd>
                            </div>
                            <div>
                                <dt className='font-semibold pb-2'>
                                    Income
                                </dt>
                                <dd className='font-light'>
                                    $2.3 Million
                                </dd>
                            </div>
                            <div>
                                <dt className='font-semibold pb-2'>
                                    Tools Used
                                </dt>
                                <dd className='font-light'>
                                    <span className='block'>Figma</span>
                                    <span className='block my-1'>Google Docs</span>
                                    <span className='block'>Miro</span>
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </>
    )
}

const QuoteSection = () => (
    <>
        <div className='relative'>
            <img src={BgBookStack} alt="" />
            <div className='w-full  absolute text-white top-1'>
                <div className='max-w-4xl mx-auto sm:py-20 text-center px-2'>
                    <p className="py-2 sm:pt-6 text-sm sm:text-3xl font-bold text-white md:leading-12 lg:text-4xl">
                        "
                        As of 2022, only a few government-owned hospitals in low- and middle-income countries use electronic 
                        health records, and the primary format of patient data storage is largely paper based 
                        <span className='block'>Adedeji et al., 2022"</span>
                        
                    </p>
                </div>
            </div>
        </div>
    </>
)

const BriefHistorySection = () => (
    <>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    About UCH
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    After completion on November 20, 1957, the university college hospital was 
                    formally commissioned with 500-bed spaces. The hospital currently has 1,000-bed 
                    spaces and 163 examination couches, with occupancy rates ranging from 55 to 60%.
                </p>
                <p className="pb-6">
                    Access to a patient's medical record facilitates prompt service delivery in a 
                    health institution because it contains a vital summary of the patient's medical 
                    history. As a result, it is an essential tool in patient management.Implementing 
                    tools that improve the ease of access to health records within a given time frame 
                    can help reduce the frustrations associated with records officers being unable 
                    to access patients' records due to time constraints, as well as help improve patients' 
                    experiences during hospital visits.
                </p>
                <p className="pb-6">
                    To this effect, the hospital administration would like an MVP built that can assist 
                    patients who want their health records transferred to the appropriate clinical 
                    department prior to their next hospital appointment.
                </p>
            </div>

            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    Business Objectives
                </h1>
            </div>
            <div className="py-4 md:py-12 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    The project's key performance indicators are to create an MVP that would enable 
                    patients to 
                </p>
                <ul className="pb-6 list-disc ml-4">
                    <li>
                        make requests for case notes easier before hospital appointment dates,
                    </li>
                    <li>
                        allow ease of document transfer to different departments before patients' arrival and
                    </li>
                    <li>
                        make hospital visits and inquiries at the medical records department less hectic for 
                        patients
                    </li>
                </ul>
                <p className="pb-6">
                    By achieving this Objective, it is expected that patients will have less stressful visits to the 
                    hospital, saving both time and improving services delivery of the records department by 85%.
                </p>
            </div>
        </div>
    </>
)

const UnderstandingProblemSection = () => (
    <>
        <div className="bg-gray-50 py-8 sm:py-24">
            <div className='container mx-auto'>
                <div className='py-2 text-center'>
                    <h1 className="text-2xl font-bold text-primary leading-12 lg:text-3xl">
                        Understanding the Problem
                    </h1>
                </div>

                <div>
                    <ul className='flex flex-wrap w-full pt-16'>
                        {
                            problemOptions.map((list, key) => (
                                <li className='w-full sm:w-1/3 py-4 my-8 sm:my-4' key={key}>
                                    <div className='bg-white py-2 mx-4 rounded-md relative'>
                                        <div className='w-full absolute -top-8'>
                                            <div className='w-20 mx-auto overflow-x-hidden' dangerouslySetInnerHTML={{ __html: list.svg }}></div>
                                        </div>
                                        <div className='px-2 text-center py-6'>
                                            <p className='text-xl text-gray-800 font-semibold py-4'>
                                                {list.title}
                                            </p>
                                            <p className='text-md px-4 font-normal text-gray-600'>
                                                {list.text}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>

            </div>
        </div>
    </>
) 

const ResearchReportSection = () => (
    <>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    Key Learnings fom Observation Study
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    In public government hospitals, the management of medical records is still heavily dependant 
                    on paper work and bureaucratic procedures. As a result, I conducted an observation and immersion 
                    study to learn firsthand about the current procedure for processing patients records.
                </p>
                <p className="pb-6">
                    I signed up as a patient for a visit at OBGYN clinic in the University College Hospital
                    specifically for this reason.
                </p>
            </div>
            <div className='flex flex-wrap w-full'>
                {
                    observationStudyContents.map((option, key) => (
                        <div className='w-full sm:w-1/3 my-8 sm:my-4' key={key}>
                            <div className="h-full w-full">
                                <div className="relative w-full flex items-center justify-center">
                                    <img src={option.img} className="mb-3 w-40 h-40 rounded-xl object-contain" alt="" />
                                </div>
                                <div className="my-3 px-1">
                                    <div className="mb-2 text-center py-1">
                                        <p className="text-lg font-bold text-navy-700">
                                            {option.heading}
                                        </p>
                                    </div>
                                    <div className="mb-2 text-center md:px-8">
                                        <ul className="mt-1 text-sm font-medium text-gray-600 md:mt-2">
                                            {
                                                option.contents.map((content, index) => (
                                                    <li className='my-2 list-item list-inside list-disc' key={index}>
                                                        {/* <span className='bg-gray-600 h-1 w-1 rounded-full'></span> */}
                                                        <span className='text-lg'>
                                                            {content}
                                                        </span>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                       
            </div>

            <div className='my-8 md:mt-12'>
                <div className='p-4 sm:p-4 md:p-12 bg-green-100 rounded-md relative'>
                    <div className='md:absolute w-32 object-contain h-auto sm:top-6 sm:right-16 mx-auto'>
                        <img src={DocumentImg} alt='character' />
                    </div>
                    <div className='py-4 w-full max-w-5xl'>
                        <h2 className='text-xl md:text-2xl py-2'>Key Findings From Observation Studies</h2>
                        <p className='text-gray-600 py-2'>
                            By becoming a patient and being immersed in the hospital environment, I was able to gain empathy towards other patients, particularly those who had to wait for extended periods to obtain their medical records from the records department. Through my observations, I discovered several things;
                        </p>
                    </div>
                    <div className='w-full max-w-5xl text-base'>
                        <ul>
                            <li className='list-inside list-disc py-4'>
                                <span className='text-gray-600 py-2'>
                                    Because the files are in physical format and a large number of patients are requesting their case notes at the same time, the current method of processing and transferring patient information may result in a lot of misplacement and lost records.
                                </span>
                            </li>
                            <li className='list-inside list-disc py-4'>
                                <span className='text-gray-600 py-2'>
                                    If returning patients' records cannot be found, a temporary record will be opened. however, if the original health record document is not found, the patient's health record information may become inconsistent, affecting prognosis.
                                </span>
                            </li>
                            <li className='list-inside list-disc py-4'>
                                <span className='text-gray-600 py-2'>
                                    Because of the large number of patients supported by the records department, the lack of physical materials required to process a patient's health record would cause a delay and may affect the patient's ability to see the doctor that same day, causing frustration on the patient's part.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className='pt-24'>
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        Healthcare Laws in Nigeria
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        I conducted research to better understand the current legal framework governing the use of a 
                        patient's medical health in public hospitals after finishing my immersion studies. I based my 
                        understanding of Nigerian healthcare laws and practices on readily available research publications. 
                        Despite the relatively recent use of electronic records in Nigerian hospitals, the following stood out to 
                        me from my research.
                    </p>
                    <div className='py-6 w-full max-w-5x mx-auto'>
                        <img alt='Rules Governing Healthcare Info in Nigeria' src={HealthCareRuleImg} />
                    </div>
                </div>
            </div>

            <div className='pt-24'>
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        User Survey and Interviews
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        In interacting with the patients at the University College Hospital, I chose both a 
                        survey and an interview because some patients who didn't have time to sit down for an 
                        interview were more open to participating in the research once they were informed that 
                        there was a survey as an alternative.
                    </p>
                    <p className="pb-6">
                        5 people took part in the physical interview with myself as the UX Researcher, while 30 
                        preferred to fill out the survey. My summary and findings are presented below.
                    </p>
                    <div className='py-6 w-full max-w-6xl mx-auto'>
                        <img alt='User Interview and Survey' src={SurveyReportImg} />
                    </div>
                </div>
                <div className='my-8'>
                    <div className='p-4 sm:p-4 md:p-12 bg-green-100 rounded-md relative'>
                        <div className='md:absolute w-32 object-contain h-auto sm:top-6 sm:right-16 mx-auto'>
                            <img src={DocumentImg} alt='character' />
                        </div>
                        <div className='py-4 w-full max-w-5xl'>
                            <h2 className='text-xl md:text-2xl py-2'>What is the shared basis?</h2>
                            <p className='text-gray-600 py-2'>
                                What is the shared or recurring element among the data gathered from the research, user interview, and user survey?
                            </p>
                        </div>
                        <div className='w-full max-w-5xl text-base'>
                            <ul>
                                <li className='list-inside list-disc py-4'>
                                    <span className='text-gray-600 py-2'>
                                        Healthcare in developing countries have a long way to go in terms of development and management of  administrative procedures involving patients and hospital staff.
                                    </span>
                                </li>
                                <li className='list-inside list-disc py-4'>
                                    <span className='text-gray-600 py-2'>
                                        It will take some time for the adoption of digital patient medical records, as it requires not only patient acceptance but also the hospital's investment in training their medical records staff to use such applications effectively to assist patients before hospital visits.
                                    </span>
                                </li>
                                <li className='list-inside list-disc py-4'>
                                    <span className='text-gray-600 py-2'>
                                        If a dependable, convenient, and swift solution is offered, patients are open to embracing novel means of obtaining their medical records.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
)

const UserNeedsSection = () => (
    <>
        <div className="bg-blue-50 py-8 sm:py-24">
            <div className='container mx-auto'>
                <div className='py-2 text-center'>
                    <h1 className="text-2xl font-bold text-primary leading-12 lg:text-3xl">
                        Defining the Problem and User Needs
                    </h1>
                </div>

                <div>
                    <ul className='flex flex-wrap w-full pt-16'>
                        {
                            needOptions.map((list, key) => (
                                <li className='w-full sm:w-1/3 my-10 sm:my-4' key={key}>
                                    <div className='bg-white py-2 mx-4 rounded-md relative'>
                                        <div className='w-full absolute -top-8'>
                                            <div className='w-20 mx-auto overflow-x-hidden' dangerouslySetInnerHTML={{ __html: list.svg }}></div>
                                        </div>
                                        <div className='px-2 text-center py-6'>
                                            <p className='text-xl text-gray-800 font-semibold py-4'>
                                                {list.title}
                                            </p>
                                            <p className='text-md px-4 font-normal text-gray-600'>
                                                {list.text}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>

            </div>
        </div>
    </>
)

const ResearchReportContinueSection = () => (
    <>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    User Persona
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    Based on the information gathered during my user interviews and surveys, I developed a clearly 
                    defined user persona that would be useful in making future design decisions. Using the persona as a 
                    reference point ensured that design decisions were made with a human-centered approach.
                </p>
                <div className='py-6'>
                    <img alt='User Persona' src={UserPersonaImage} />
                </div>
            </div>

            <div className='pt-24'>
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        HMW Template
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        Based on my research findings and a clearly defined problem statement, I used the how might 
                        we template to pose questions to myself and other UX designers in my group crit team to gain 
                        better understanding of the best solution that could be offered to the current problem.
                    </p>
                    <div className='py-6'>
                        <img alt='HMW Template' src={HMWTemplateImg} />
                    </div>
                </div>
            </div>

            <div className='pt-24 hidden'>
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        User Survey and Interviews
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        In interacting with the patients at the University College Hospital, I chose both a 
                        survey and an interview because some patients who didn't have time to sit down for an 
                        interview were more open to participating in the research once they were informed that 
                        there was a survey as an alternative.
                    </p>
                    <p className="pb-6">
                        5 people took part in the physical interview with myself as the UX Researcher, while 30 
                        preferred to fill out the survey. My summary and findings are presented below.
                    </p>
                    <div className='py-6'>
                        <img alt='User Interview and Survey' src={SurveyReportImg} />
                    </div>
                </div>
            </div>
        </div>
    </>
)

const PointConvergenceSection = () => (
    <>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    What is the point of convergence
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    I was able to fully emphasize the user, business and technological goals, as well as the areas where 
                    the intersected, at this point. This simplified addressing the problem statement based on the available facts.
                </p>
                <div className='py-6'>
                    <img alt='Point of Convergence' src={TechnicalBusinessImg} />
                </div>
            </div>

            <div className='my-8'>
                <div className='p-4 sm:p-4 md:p-8 bg-green-100 rounded-md relative'>
                    <div className='md:absolute w-32 object-contain h-auto sm:top-6 sm:right-16 mx-auto'>
                        <img src={VoiceAssistantImg} alt='character' />
                    </div>
                    <div className='py-4 w-full max-w-5xl'>
                        <h2 className='text-xl md:text-2xl py-2'>Quick Fact</h2>
                        <p className='text-gray-600 py-2'>
                            Making the application language accessible is essential for its functionality, as the target audience is located in Nigeria, a country with three major ethnic groups and over 400 tribes. In order to cater to patients from various regions of the country and ensure that they can use the application, it is necessary to offer it in multiple languages such as English, Pidgin, Yoruba, Igbo, and Hausa. This will enable a wider range of patients to access the application for requesting medical records.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </>
)

const PerfectSolutionSection = () => (
    <>
        <div className="bg-green-50 py-8 sm:py-24">
            <div className='container mx-auto'>
                <div className='py-2 text-center'>
                    <h1 className="text-2xl font-bold text-primary leading-12 lg:text-3xl">
                        Coming up with the perfect solutions
                    </h1>
                </div>

                <div>
                    <ul className='flex flex-wrap w-full pt-16'>
                        {
                            solutionOptions.map((list, key) => (
                                <li className='w-full sm:w-1/2 my-4' key={key}>
                                    <div className='bg-white py-4 mx-4 rounded-md relative'>
                                        <div className='px-2 sm:px-8 md:px-12 text-center py-6'>
                                            <p className='text-xl text-gray-800 font-semibold py-4'>
                                                {list.title}
                                            </p>
                                            <p className='text-md px-4 font-normal text-gray-600'>
                                                {list.text}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>

            </div>
        </div>
    </>
) 

const InformationArchitectureSection = () => (
    <>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    Information Architecture
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                    Now that I had a clear understanding of the problem and what the users' needs might be, I devised the information architecture needed to create an MVP that is both viable and functional. Developing the information architecture simplified the process of securing approval from stakeholders for the project before moving on to creating wireframes for crucial screens in the application.
                </p>
                <div className='py-6 w-full max-w-5xl mx-auto'>
                    <img alt='Information Architecture' src={InformationArchitectureImg} />
                </div>
            </div>
        </div>
        <div className="bg-white py-8 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    User Flow
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                   It was simple to create two scenarios based on the information architecture that would demonstrate 
                   how a patient would interact with the product in order to make a file request before arriving at the 
                   hospital.
                </p>
                <div className='py-6 w-full max-w-5xl mx-auto'>
                    <img alt='User Flow' src={UserFlowImg} />
                </div>
            </div>
        </div>
        <div className="bg-white py-8 sm:py-24 container mx-auto px-4 sm:px-0">
            <div className='border-l-2 border-primary pl-4 py-2'>
                <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                    Paper Sketches
                </h1>
            </div>
            <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                <p className="pb-6">
                   I drew some sketches on paper with a pen to see how some of the key screens would look and to test 
                   the feasibility before moving to high fidelity.
                </p>
                <div className='py-6 max-w-5xl mx-auto space-y-4'>
                    <img alt='Signin Sketch' src={SignInSketch} />
                    <img alt='Signup Sketch' src={SignUpSketch} />
                    <img alt='Main Screen Sketch' src={MainScreenSketch} />
                </div>
                <div className='py-4 md:py-8 leading-9 text-xl md:text-2xl'>
                    <p className="pb-6">
                        After drawing my sketches, I was able to:
                    </p>
                    <ul className='space-y-4 list-disc pl-4 sm:pl-8'>
                        <li>
                            run a quick paper prototype to see the potential interactions between the screens
                        </li>
                        <li>iterate on some of the flows in my paper prototype</li>
                        <li>have a better idea of how the final design will look</li>
                    </ul>
                </div>
                <div className='py-4 md:py-12 leading-9 text-xl md:text-2xl max-w-5xl mx-auto text-center'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        The Design
                    </h1>
                    <p className="pb-6 pt-4">
                        I used components and the existing style guide to create the first version of the  
                        app after a series of iterations from paper sketches and low fidelity wire frames.
                    </p>
                </div>

                <div className='py-6 container mx-auto'>
                    <div style={{ position: 'relative', paddingBottom: '51.5625%', height: 0 }}>
                        <iframe 
                            src="https://www.loom.com/embed/67446f9f77f6413e9c449ffb705a3dac?sid=665f821f-ee60-4ca8-b73f-aba33bd4eaa6" 
                            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen title='Videos'
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', }}
                        ></iframe>
                    </div>
                </div>

                <div className='py-6 container mx-auto w-full max-w-5xl'>
                    <img alt='Splash Screen Design' src={SplashScreenImg} />
                    <img alt='Signin Screen Design' src={SigninScreenImg} />
                    <img alt='Navigation Screen Design' src={NavigationScreenImg} />
                    <img alt='Records Screen Design' src={RecordScreenImg} />
                </div>
            </div>
            <div className="bg-white py-8 sm:py-24 container mx-auto">
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        Getting Feedback
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        I conducted usability studies with patients who interacted with the available prototype via mobile 
                        phone and recorded feedback recommendations. I used the diagram below to summarize my user testing results.
                    </p>
                    <div className='py-6 w-full max-w-5xl mx-auto'>
                        <img alt='Usability Studies' src={UsabilityStudiesImg} />
                    </div>
                </div>
            </div>
            <div className="bg-white py-8 sm:py-24 container mx-auto">
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        Making Adjustments
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        Based on the findings of the usability studies, I made some changes to the current design, such as 
                        allowing users to choose their preferred language for using the app. This is due to the targe 
                        population speaking four major languages, which if accommodated in the design will allow patients 
                        who do not speak English to use the application.
                    </p>
                    <div className='py-6 space-y-6 w-full max-w-5xl mx-auto'>
                        <img alt='Making Adjustment' src={MakingAdjustmentImg} />
                        <img alt='Request Form' src={RequestFormImg} />
                        <img alt='Request Form' src={RequestFormProcessImg} />
                    </div>
                </div>
            </div>
            <div className="bg-white -pt-8 container mx-auto">
                <div className='border-l-2 border-primary pl-4 py-2'>
                    <h1 className="text-3xl font-bold text-primary leading-12 lg:text-4xl">
                        Reflection and Next Steps
                    </h1>
                </div>
                <div className="py-4 md:py-8 leading-9 text-xl md:text-2xl">
                    <p className="pb-6">
                        Working on this project presented challenges, but it also provided an opportunity to 
                        learn about Nigeria's healthcare system. Although this is the first step in the right 
                        direction for managing patient health record information at UCH, future versions of the 
                        app can also accommodate processes in which all record information used within the 
                        hospital is fully digital as opposed to the paper format currently in use.
                    </p>

                    <p className="pb-6">My next steps would be as follows:</p>

                    <ul className='space-y-4 list-disc pl-4 sm:pl-8 text-lg'>

                        <li>
                            Meeting with stake holders at the records department to gather feedback that can be used for further iteration
                        </li>

                        <li>
                            Coming up with a product road to accommodate  new features to be introduced
                        </li> 

                        <li>
                            Make final adjustments to the screen and other components
                        </li>

                        <li>
                            Hand Off Designs to the developers
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </>
)

const StatementSection = () => (
    <>
         <div>
            <div className='relative text-white'>
                <img alt='statement text' src={StatementTextImg} />
                <div className="absolute top-0 w-full">
                    <div className='max-w-4xl mx-auto w-full flex flex-col items-center py-1 sm:py-20'>
                        <h2 className='text-sm sm:text-2xl font-semibold leading-6'>Problem Statement</h2>
                        <p className='text-xs sm:text-2xl font-semibold sm:leading-7 sm:py-2 text-center'>
                            "How do you make reduce the frustrations and inconsistencies that patients experience when 
                            requesting their medical records prior to/during a hospital visit.?"
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </>
)

export const UCHShowcase = () => {
    return (
        <>
            <Layout>
                <Hero />

                <OverviewSection />

                <QuoteSection />

                <BriefHistorySection />

                <UnderstandingProblemSection />

                <ResearchReportSection />
                
                <UserNeedsSection />

                <ResearchReportContinueSection />

                <StatementSection />

                <PointConvergenceSection />

                <PerfectSolutionSection />

                <InformationArchitectureSection />

                <ShowcasePagination data={caseStudyLists[1]} />
                
            </Layout>
        </>
    )
}